<template>
    <tab-layout :buttons="buttons" :permissions="permissions" :parameters="[{key: 'linkedid', value: linkedid}]">
        <template #title>
            {{ more.title }}
        </template>

        <template #content>
            <div class="prelative min-h-100">
                <preloader :display="loading"/>
                <div v-if="!loading" id="briefcase-v1" v-html="htmlData"></div>
            </div>
            
        </template>
    </tab-layout>
</template>

<script>
    import OverviewTabMixin from './OverviewTabMixin'
    import { buildUrl } from '../../../helpers';
    import Preloader from "vcomponents/utilities/Preloader.vue";
    import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

    export default {
        mixins: [OverviewTabMixin],
        props: {
            more: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                permissions: {},
                loading: true,
                htmlData: '',
                response : false
            }
        },
        created(){
            this.fetch().then(() => {
                this.initBriefcasev1()
            })
        },
        computed: {
            buttons(){
                return this.more.buttons.map(button => {
                    // button.linkedid = this.$store.getters.linkedid
                    // button.linkedtype = this.$store.getters.linkedtype
                    return button
                })
            },
        },
        methods: {
            fetch() {
                return new Promise((resolve, reject) => {

                    this.loading = true
                    var params = {
                        action		    : this.more.action, 
                        linkedid        : buildUrl(this.more.linkedid, [{key: 'linkedid', value: this.linkedid}]),
                        linkedtype      : buildUrl(this.more.linkedtype, [{key: 'linkedtype', value: this.linkedtype}]),
                        linkedtypeDir   : this.more.linkedtypeDir,
                        linkedname      : this.$store.getters.identity.name,
                        editpermission  : this.more.editpermission,
                    };
                    axios.post(this.more.url, params)
                        .then((response) => {
                            if (response.data.listing !== undefined) {
                                this.htmlData = response.data.listing
                                this.response = response.data
                                this.loading = false
                                resolve()
                            } else{
                                this.htmlData = response.data.error;
                            }
                        })
                        .catch((error) => {
                            
                        })
                })
                
                
            },
            initBriefcasev1(){
                BriefCaseV2Light.init();
                MyFacture.customForm();
            }
        },

        components: {
            Preloader,
            TabLayout,
        }
    }
</script>

<style lang="scss">


</style>